export default {
  baseUrl: "https://api.gen-air.viserx.net/api",
  // "baseUrl": 'http://nafappapi.viserx.net/api',
  // baseUrl: "http://gen-air.test/api", 
}; 